import { FC } from "react";
import styled from "styled-components";

import { DATA_E2E_KEY, IRideDto, IStyledAttributes } from "@ryde/shared";

import { RideMlPathIndicator } from "../../common";

const MlPathIndicatorCellStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ml-path-indicator-cell",
})`
  display: inline-flex;
  align-items: center;
`;

export const MlPathIndicatorCell: FC<Partial<IRideDto>> = rideDto => {
  return (
    <MlPathIndicatorCellStyled className="allow-overflow">
      <RideMlPathIndicator {...rideDto} />
    </MlPathIndicatorCellStyled>
  );
};
